import { Fragment, useMemo } from "react";
import { useSelector } from "react-redux";

import Timer from "@/design/components/Timer";
import { getUserName } from "@/utils/utility";
import Valkyrie, { viPause, viPhone, viPhoneArrowDownLeft, viPhoneArrowUpRight } from "@sippy-platform/valkyrie";

import { Divider, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import PropTypes from "prop-types";

function ActiveCalls({ user, activeCalls }) {
  const userStore = useSelector((state) => state.domain.users);
  const username = user.username;

  const ongoingCalls = useMemo(() => {
    return activeCalls
      .map((dialog) => {
        let callDirectionLabel;
        let onHoldLabel = "";
        let caller;
        let iconCalling;
        let iconInCall;

        if (dialog.caller !== username) {
          callDirectionLabel = "Incoming from";
          caller = dialog.caller;
          iconCalling = viPhoneArrowDownLeft;
          iconInCall = viPhone;
        } else {
          callDirectionLabel = "Outgoing to";
          caller = dialog.callee;
          iconCalling = viPhoneArrowUpRight;
          iconInCall = viPhone;
        }

        if (dialog.onHold === "true") {
          onHoldLabel = "(On hold)";
          iconCalling = viPause;
          iconInCall = viPause;
        }

        if (dialog) {
          const user = getUserName(caller, userStore.list);
          let callerText = user ? `${user} (${caller})` : caller;

          if (dialog.method === "INVITE") {
            return {
              icon: iconCalling,
              description: `${callDirectionLabel} ${callerText} ${onHoldLabel}`,
              time: Number(dialog.timeStart),
              callId: dialog.callID,
            };
          } else if (dialog.method === "ACK") {
            return {
              icon: iconInCall,
              description: `In call with ${callerText} ${onHoldLabel}`,
              time: Number(dialog.timeAnswer),
              callId: dialog.callID,
            };
          }
        }
      })
      .filter((a) => a);
  }, [activeCalls, userStore.list, username]);

  // Filter any empty calls from the map
  return (
    <>
      {ongoingCalls.map((call) => (
        <Fragment key={call.callId}>
          <Divider
            variant="inset"
            component="li"
            sx={{ listStyle: "none", ml: 7.5, mr: 2, mb: "-1px", borderColor: (theme) => theme.vars.palette.divider }}
          />
          <ListItem
            sx={{
              minHeight: 32,
              py: 0.5,
            }}
          >
            <ListItemIcon sx={{ px: 0, minWidth: 32, fontSize: ".75rem", justifyContent: "center", mr: 1.5 }}>
              <Valkyrie icon={call.icon} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: ".75rem", minWidth: 0 }} noWrap>
                  {call.description}
                </Typography>
              }
            />
            <ListItemIcon sx={{ justifyContent: "flex-end", pr: 0, py: 0 }}>
              <Typography
                sx={{ fontSize: ".75rem", minWidth: 0, fontVariantNumeric: "tabular-nums" }}
                color="textSecondary"
              >
                <Timer startTime={call.time} />
              </Typography>
            </ListItemIcon>
          </ListItem>
        </Fragment>
      ))}
    </>
  );
}

ActiveCalls.propTypes = {
  activeCalls: PropTypes.array,
  user: PropTypes.object,
};

export default ActiveCalls;
